import { AuthState } from '../store/auth'

export type Page = 'dashboard' | 'squad' | 'tactics' | 'fixtures' | 'match' | 'transfer' | 'stock' | 'banking' | 'cup' | 'finance' | 'news' | 'setpiece'

interface Props {
  current:    Page
  onChange:   (p: Page) => void
  auth:       AuthState
  clubName:   string
  cash:       number
  onLogout:   () => void
}

const TABS: { key: Page; label: string }[] = [
  { key: 'dashboard', label: '대시보드' },
  { key: 'squad',     label: '선수단' },
  { key: 'tactics',   label: '전술' },
  { key: 'fixtures',  label: '일정·순위' },
  { key: 'transfer',  label: '이적시장' },
  { key: 'stock',     label: '주식' },
  { key: 'banking',   label: '은행' },
  { key: 'cup',       label: '컵대회' },
  { key: 'setpiece',  label: '세트피스' },
  { key: 'finance',   label: '재정' },
  { key: 'news',      label: '뉴스' },
]

export default function NavBar({ current, onChange, auth, clubName, cash, onLogout }: Props) {
  return (
    <nav className="nav-bar">
      <div className="nav-left">
        <h1 className="nav-title">Web FM</h1>
        <div className="nav-tabs">
          {TABS.map(t => (
            <button
              key={t.key}
              className={current === t.key ? 'nav-tab active' : 'nav-tab'}
              onClick={() => onChange(t.key)}
            >{t.label}</button>
          ))}
        </div>
      </div>
      <div className="nav-right">
        <span className="nav-club">{clubName}</span>
        <span className="nav-cash">₩ {cash.toLocaleString()}</span>
        <span className="nav-user">{auth.userName} 감독</span>
        <button className="nav-logout" onClick={onLogout}>로그아웃</button>
      </div>
    </nav>
  )
}
